import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55401c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-profile-info__form" }
const _hoisted_2 = { class: "items-in-line mt--20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Вы уверены, что хотите удалить файл?", -1))
const _hoisted_4 = { class: "items-in-line" }

import { computed, onMounted, ref, Ref } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ErrorsType, FileType } from '@/types';
import { vMaska } from 'maska';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { BaseFileInput } from '@/components/UI';
import { UserType, useUserStore } from '@/store/modules/user';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/store/modules/app';

type FormDataType = {
  phone: string | undefined;
  name: string | undefined;
  logo: { [key: string]: File } | undefined;
  logoFile: FileType | undefined;
};
type CompanyFormDataType = {
  logoCompany: { [key: string]: File } | undefined;
  logoCompanyFile: FileType | undefined;
  titleCompany: string | undefined;
  siteCompany: string | undefined;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfileInfo',
  setup(__props) {

const formData: Ref<FormDataType> = ref({
  phone: undefined,
  name: undefined,
  logo: undefined,
  logoFile: undefined,
});
const companyFormData: Ref<CompanyFormDataType> = ref({
  logoCompany: undefined,
  logoCompanyFile: undefined,
  titleCompany: undefined,
  siteCompany: undefined,
});
const userType = computed((): number | undefined => {
  return useUserStore().user?.type;
});
const clearFormData = () => {
  v$.value.$reset();
  for (const [key] of Object.entries(formData.value)) {
    formData.value[key as keyof FormDataType] = undefined;
  }
};

const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  phone: { required },
  logo: {},
  logoFile: {},
  name: { required },
};
const companyRules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  logoCompany: {},
  logoCompanyFile: {},
  titleCompany: {},
  siteCompany: {},
};
const v$ = useVuelidate<FormDataType>(rules, formData);
const vc$ = useVuelidate<CompanyFormDataType>(companyRules, companyFormData);

const errors: Ref<ErrorsType> = ref({});

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const prepareDataForSend = (): FormData => {
  let sendData = new FormData();
  const copyFormData =
    userType.value !== 1
      ? { ...formData.value, ...companyFormData.value }
      : formData.value;

  for (let key in copyFormData) {
    let name = key;
    let value: string;

    if (key !== 'logoCompanyFile' && key !== 'logoFile') {
      if (key === 'logo') {
        if (formData.value[key as keyof FormDataType]) {
          Object.values(
            formData.value[key] as {
              [key: string]: File | null;
            },
          ).forEach(val => {
            if (val !== null) {
              sendData.append(`parameters[${name}]`, val);
            }
          });
        }
      } else if (key === 'logoCompany') {
        if (companyFormData.value[key as keyof CompanyFormDataType]) {
          Object.values(
            companyFormData.value[key] as {
              [key: string]: File | null;
            },
          ).forEach(val => {
            if (val !== null) {
              sendData.append(`parameters[${name}]`, val);
            }
          });
        }
      } else {
        if (key === 'phone') {
          value = formData.value.phone?.replace(/[^\d]/g, '') ?? '';
        } else {
          value = (copyFormData[key as keyof FormDataType] as string) ?? '';
        }

        sendData.append(`parameters[${name}]`, value);
      }
    }
  }

  return sendData;
};
const loading = ref(false);
const router = useRouter();
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  if (userType.value !== 1) {
    if (vc$.value.$invalid) {
      vc$.value.$touch();
      validationErrorsHandler();

      return;
    }
  }
  loading.value = true;

  try {
    const res = await useUserStore().updateUserInfo(prepareDataForSend());

    if (res) {
      await router.push({ query: { id: 'info' } });
      clearFormData();
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};
const userInfo = computed((): UserType | undefined => {
  return useUserStore().user;
});

const modalData: Ref<{
  show: boolean;
  inputId: undefined | string;
  btnLoading: boolean;
}> = ref({
  show: false,
  inputId: undefined,
  btnLoading: false,
});

const openModal = (inputId: string) => {
  modalData.value = {
    show: true,
    inputId: inputId,
    btnLoading: false,
  };
};
const deleteFile = async () => {
  if (modalData.value.inputId) {
    try {
      modalData.value.btnLoading = true;

      const res =
        modalData.value.inputId === 'logo'
          ? await useUserStore().deleteLogo()
          : await useUserStore().deleteCompanyLogo();

      if (res) {
        useAppStore().openAlert('', 'Файл удален');
        if (modalData.value.inputId === 'logo') {
          formData.value.logoFile = undefined;
        } else {
          companyFormData.value.logoCompanyFile = undefined;
        }
      }
    } finally {
      closeModal();
      modalData.value.btnLoading = false;
    }
  }
};
const closeModal = () => {
  modalData.value = {
    show: false,
    inputId: undefined,
    btnLoading: false,
  };
};

onMounted(() => {
  formData.value = {
    ...formData.value,
    phone: userInfo.value?.phone,
    name: userInfo.value?.name,
    logoFile: userInfo.value?.logo
      ? { id: 1, path: userInfo.value?.logo, name: 'Логотип' }
      : undefined,
  };
  if (userType.value !== 1) {
    companyFormData.value = {
      logoCompanyFile: userInfo.value?.profile.logoCompany
        ? {
            id: 2,
            path: userInfo.value?.profile.logoCompany,
            name: 'Логотип компании',
          }
        : undefined,
      siteCompany: userInfo.value?.profile.siteCompany,
      titleCompany: userInfo.value?.profile.titleCompany,
      logoCompany: undefined,
    };
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_base_input, {
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
            error: errors.value.name,
            invalid: !!errors.value.name,
            height: "36",
            label: "Имя",
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('name'))),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.name)),
            onInput: _unref(v$).name.$touch
          }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
          _withDirectives(_createVNode(_component_base_input, {
            modelValue: formData.value.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phone) = $event)),
            error: errors.value.phone,
            invalid: !!errors.value.phone,
            "data-maska": "(###)###-##-##",
            height: "36",
            label: "Телефон",
            placeholder: "(999)000-99-99",
            prefix: "+7 ",
            onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('phone'))),
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.phone)),
            onInput: _unref(v$).phone.$touch
          }, null, 8, ["modelValue", "error", "invalid", "onInput"]), [
            [_unref(vMaska)]
          ]),
          _createVNode(_unref(BaseFileInput), {
            modelValue: formData.value.logo,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.logo) = $event)),
            error: errors.value.logo,
            files: formData.value.logoFile,
            invalid: !!errors.value.logo,
            height: "36",
            label: "Фото",
            withIcon: "",
            onBlur: _cache[7] || (_cache[7] = ($event: any) => (validationErrorsHandlerByKey('logo'))),
            onDeleteFile: _cache[8] || (_cache[8] = ($event: any) => (openModal('logo'))),
            onFocus: _cache[9] || (_cache[9] = ($event: any) => (delete errors.value.logo)),
            onInput: _unref(v$).logo.$touch
          }, null, 8, ["modelValue", "error", "files", "invalid", "onInput"]),
          (userType.value !== 1)
            ? (_openBlock(), _createBlock(_component_base_input, {
                key: 0,
                modelValue: companyFormData.value.titleCompany,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((companyFormData.value.titleCompany) = $event)),
                error: errors.value.titleCompany,
                invalid: !!errors.value.titleCompany,
                height: "36",
                label: "Название компании",
                onBlur: _cache[11] || (_cache[11] = ($event: any) => (validationErrorsHandlerByKey('titleCompany'))),
                onFocus: _cache[12] || (_cache[12] = ($event: any) => (delete errors.value.titleCompany)),
                onInput: _unref(vc$).titleCompany.$touch
              }, null, 8, ["modelValue", "error", "invalid", "onInput"]))
            : _createCommentVNode("", true),
          (userType.value !== 1)
            ? (_openBlock(), _createBlock(_component_base_input, {
                key: 1,
                modelValue: companyFormData.value.siteCompany,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((companyFormData.value.siteCompany) = $event)),
                error: errors.value.siteCompany,
                invalid: !!errors.value.siteCompany,
                height: "36",
                label: "Сайт компании",
                onBlur: _cache[14] || (_cache[14] = ($event: any) => (validationErrorsHandlerByKey('siteCompany'))),
                onFocus: _cache[15] || (_cache[15] = ($event: any) => (delete errors.value.siteCompany)),
                onInput: _unref(vc$).siteCompany.$touch
              }, null, 8, ["modelValue", "error", "invalid", "onInput"]))
            : _createCommentVNode("", true),
          (userType.value !== 1)
            ? (_openBlock(), _createBlock(_unref(BaseFileInput), {
                key: 2,
                modelValue: companyFormData.value.logoCompany,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((companyFormData.value.logoCompany) = $event)),
                error: errors.value.logoCompany,
                files: companyFormData.value.logoCompanyFile,
                invalid: !!errors.value.logoCompany,
                height: "36",
                label: "Логотип компании",
                withIcon: "",
                onBlur: _cache[17] || (_cache[17] = ($event: any) => (validationErrorsHandlerByKey('logoCompany'))),
                onDeleteFile: _cache[18] || (_cache[18] = ($event: any) => (openModal('logoCompany'))),
                onFocus: _cache[19] || (_cache[19] = ($event: any) => (delete errors.value.logoCompany)),
                onInput: _unref(vc$).logoCompany.$touch
              }, null, 8, ["modelValue", "error", "files", "invalid", "onInput"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_button, {
            disabled: loading.value,
            href: { query: { id: 'info' } },
            height: "40",
            "style-type": "coloredBorder",
            text: "Отмена"
          }, null, 8, ["disabled"]),
          _createVNode(_component_base_button, {
            loading: loading.value,
            height: "40",
            text: "Сохранить",
            onClick: formSubmit
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "show-modal": modalData.value.show,
      "hide-title": "",
      onClose: closeModal
    }, {
      content: _withCtx(() => [
        _hoisted_3
      ]),
      btn: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_base_button, {
            height: "40",
            "style-type": "border",
            text: "Отмена",
            width: "118",
            onClick: closeModal
          }),
          _createVNode(_component_base_button, {
            loading: modalData.value.btnLoading,
            height: "40",
            text: "Да",
            width: "118",
            onClick: deleteFile
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["show-modal"])
  ]))
}
}

})